import { useEffect, useState } from "react";
import io from "socket.io-client";
import { useSelector } from "react-redux";
import { BsBell, BsBellFill } from "react-icons/bs";
import dayjs from "dayjs";
import "./NotificationCenter.scss";
import { selectCurrentUser } from "../../features/auth/authSlice";
import {
  useGetUnreadNotificationsQuery,
  useMarkNotificationAsReadMutation,
} from "../../features/api/notificationApiSlice";

const socket = io(import.meta.env.VITE_APP_API_URL, { withCredentials: true });
//const socket = io("http://localhost:3500", { withCredentials: true });

const NotificationDropdown = () => {
  const user = useSelector(selectCurrentUser);
  const { data: notifications = [], refetch } =
    useGetUnreadNotificationsQuery();
  const [markAsRead] = useMarkNotificationAsReadMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user?.id || user?._id) {
      socket.emit("join", user?.id || user?._id);
    }

    socket.on("new-notification", () => {
      refetch();
    });

    return () => socket.off("new-notification");
  }, [user, refetch]);

  const handleRead = async (id) => {
    await markAsRead(id);
  };

  return (
    <div className="notification-container">
      <button
        aria-label="Notifications"
        onClick={() => setOpen(!open)}
        className="notify-toggle icon-btn"
      >
        {notifications?.length ? <BsBellFill /> : <BsBell />}
        {notifications.length > 0 && (
          <span className="notify-count">{notifications.length}</span>
        )}
      </button>
      <div className={`notification-panel ${open ? "show" : ""}`}>
        <div className="notification-panel-inner">
          <h2>Notifications</h2>
          {notifications.length === 0 ? (
            <p className="notification-empty">No new notifications</p>
          ) : (
            notifications.map((notification) => (
              <div key={notification._id} className="notification-item">
                <p>{notification.message}</p>

                <small className="notification-time">
                  {dayjs(notification.createdAt).format("MMM D, YYYY h:mm A")}
                </small>

                {notification.link && (
                  <a href={notification.link} className="notification-link">
                    View
                  </a>
                )}
                <button onClick={() => handleRead(notification._id)}>
                  Mark as read
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationDropdown;
